var exports = {
  "k": "x61f99309--f6c2be--container",
};

module.exports = exports;
